<template>
<footer class="section footer">
  <div class="section__container footer__container">
    <a class="footer__logo" href="">
      <img src="../../assets/images/logo.svg" alt="лого">
    </a>
    <p class="footer__copyright">
      © 2021 OFD.ru. Все права защищены. <br>
      В случае копирования материалов, указание web-ссылки на первоисточник обязательно. <br>
      <a href="mailto:ofd@ofd.ru">Сообщить об ошибке</a>.
      <a href="https://static.ofd.ru/ofdru/politic/privacy_policy.pdf" target="_blank">Политика конфиденциальности</a>
    </p>
    <div class="footer__contact">
      <a href="tel:+74955409911" class="footer__phone">+ 7 (495) 540-99-11</a>
      <a href="mailto:rsb-ferma@ofd.ru" class="footer__email">rsb-ferma@ofd.ru</a>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
